<template>
  <v-dialog v-model="dialogFi.ativo">
    <v-row>
      <v-col cols="12" md="4" class="mx-auto" style="">
        <v-card style="max-height: 80vh !important; overflow: scroll">
          <v-row>
            <v-col>
              <v-card-title>
                <h2>Pedido Nº {{ dialogFi.pedido.num }}</h2>
              </v-card-title>
              <v-card-text class="d-flex">
                <p class="font-weight-bold">Status:</p>

                <p
                  class="px-2 font-weight-bold rounded-xl text-white"
                  :style="classStatus"
                >
                  {{
                    dialogFi.pedido.status == null
                      ? "Enviado"
                      : dialogFi.pedido.status == "Aceito"
                      ? "Aceito"
                      : dialogFi.pedido.status == "recebido"
                      ? "Em Producao"
                      : dialogFi.pedido.status.match("tele")
                      ? "Pronto"
                      : "Finalizado"
                  }}
                </p>
              </v-card-text>
              <v-card-subtitle>
                Nome: {{ dialogFi.pedido.dadosCliente.nome }}
              </v-card-subtitle>
              <v-card-subtitle>
                Cpf: {{ dialogFi.pedido.dadosCliente.cpf }}
              </v-card-subtitle>

              <v-card-text>
                <p>Número: {{ dialogFi.pedido.clienteNum }}</p>
                <template v-if="dialogFi.pedido.dataEntrega">
                  Data Entrega:
                  {{
                    dialogFi.pedido.dataEntrega.split("-").reverse().join("/")
                  }}
                  <p>
                    Hora Entrega:
                    {{
                      dialogFi.pedido.horaEntrega.split("-").reverse().join("/")
                    }}
                  </p>
                </template>
                <p v-if="this.dialogFi.pedido.dadosCliente.endereco">
                  Endereco: {{ this.dialogFi.pedido.dadosCliente.endereco }}, {{  this.dialogFi.pedido.dadosCliente.numero ?  this.dialogFi.pedido.dadosCliente.numero + ', ' +  this.dialogFi.pedido.dadosCliente.bairro.nome + ' - ' +  this.dialogFi.pedido.dadosCliente.complemento : '' }}
                </p>
              </v-card-text>
              <v-card-text>
                <h2>Produtos:</h2>
              </v-card-text>
              <v-card-text
                v-for="(produto, index) in dialogFi.pedido.produtos"
                :key="produto"
              >
                <div class="d-flex mt-4">
                  <div class="justify-content-left" style="width: 100%">
                    <p>{{ index + 1 }} -- {{ produto.nome }}</p>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="justify-content-left ml-2" style="width: 80%">
                    <p>{{ produto.quantidade }} x {{ produto.valor }}</p>
                  </div>
                  <div
                    class="justify-content-right text-left"
                    style="width: 20%"
                  >
                    <p>
                      {{
                        (parseFloat(produto.valor) * produto.quantidade)
                          .toFixed(2)
                          .replace(".", ",")
                      }}
                    </p>
                  </div>
                </div>

                <div v-if="produto.saborComp">
                  <div class="d-flex">
                    <div class="justify-content-left" style="width: 100%">
                      <strong>Sabores: </strong>
                    </div>
                  </div>
                  <div class="d-flex ml-2">
                    <div class="justify-content-left" style="width: 80%">
                      <p>{{ produto.saboresDesc }}</p>
                    </div>
                    <div
                      class="justify-content-right text-left"
                      style="width: 20%"
                    >
                      <p>
                        {{
                          parseFloat(produto.valorSaboresDesc)
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="produto.adicionaisDesc">
                  <div class="d-flex">
                    <div class="justify-content-left" style="width: 100%">
                      <p>Adicionais:</p>
                    </div>
                  </div>
                  <div class="d-flex ml-2">
                    <div class="justify-content-left" style="width: 80%">
                      <p>{{ produto.adicionaisDesc }}</p>
                    </div>
                    <div
                      class="justify-content-right text-left"
                      style="width: 20%"
                    >
                      <p>
                        {{
                          parseFloat(produto.precoAdicionais)
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-if="parseInt(index) == dialogFi.pedido.produtos.length - 1"
                  class="mt-4"
                >
                  <div class="d-flex" v-if="dialogFi.pedido.valorTele">
                    <div class="justify-content-left" style="width: 80%">
                      <p>Valor Tele:</p>
                    </div>
                    <div
                      class="justify-content-right text-left"
                      style="width: 20%"
                    >
                      <p>
                        {{
                          parseFloat(dialogFi.pedido.valorTele)
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="justify-content-left" style="width: 80%">
                      <p>Valor total</p>
                    </div>
                    <div
                      class="justify-content-right text-left"
                      style="width: 20%"
                    >
                      <strong>{{
                        parseFloat(dialogFi.pedido.preco)
                          .toFixed(2)
                          .replace(".", ",")
                      }}</strong>
                    </div>
                  </div>
                </div>
              </v-card-text>

              <v-card-text>
                <p v-if="dialogFi.pedido.observacao">
                  Observação: <strong>{{ dialogFi.pedido.observacao }}</strong>
                </p>
                <p>
                  Ambiente de pagamento:
                  <strong>{{
                    dialogFi.pedido.ambientePgto
                      ? dialogFi.pedido.ambientePgto
                      : "Pagar na entrega/retirada"
                  }}</strong>
                </p>
                <p>
                  Forma de Pagamento:
                  <strong>{{ dialogFi.pedido.metodoPgto }}</strong>
                </p>
                <p
                  v-if="
                    dialogFi.pedido.ambientePgto
                      ? dialogFi.pedido.ambientePgto !=
                          'Pagar na entrega/retirada' &&
                        this.statusPgto.message != 'No matching document found'
                      : false
                  "
                >
                  Status do pagamento:
                  <strong>{{
                    this.dialogFi.pedido.statusPgto.data.payment.status == "CON"
                      ? "Concluido"
                      : this.dialogFi.pedido.statusPgto.data.payment.status ==
                        "PEN"
                      ? "Pendente"
                      : this.dialogFi.pedido.statusPgto.data.payment.status ==
                        "NOV"
                      ? "Gerado"
                      : this.dialogFi.pedido.statusPgto.data.payment.status ==
                        "CAN"
                      ? "Cancelado"
                      : this.dialogFi.pedido.statusPgto.data.payment.status ==
                        "NEG"
                      ? "Negado"
                      : this.dialogFi.pedido.statusPgto.data.payment.status ==
                        "EXP"
                      ? "Expirado"
                      : "Erro no pagamento"
                  }}</strong>
                </p>

                <p v-if="dialogFi.pedido.valorTroco">
                  Valor Troco:
                  <strong>{{
                    parseFloat(dialogFi.pedido.valorTroco)
                      .toFixed(2)
                      .replace(".", ",")
                  }}</strong>
                </p>
                <p>
                  Modo de entrega:
                  <strong>{{
                    dialogFi.pedido.valorTele ? "Tele" : "Retirada"
                  }}</strong>
                </p>
              </v-card-text>
              <v-row class="d-flex justify-space-around">
                <v-col cols="12" class="text-center">
                  <span style="color: grey">Fechar</span>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-space-around pb-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="dialogFi.ativo = false"
                    size="small"
                    icon="mdi-close"
                    label="Fechar"
                    color="red"
                  ></v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { store } from "../store/store";

export default {
  name: "dialogPedido",
  data: () => ({
    classStatus: "",
    statusPgto: {
      message: "",
      data: {
        payment: { status: "" },
      },
    },
  }),
  watch: {
    async "dialogFi.pedido"() {
      this.classStatus = this.dialogFi.pedido
        ? {
            "background-color": `${
              this.dialogFi.pedido.status == null
                ? "#9C27B0"
                : this.dialogFi.pedido.status == "Aceito"
                ? "#3F51B5"
                : this.dialogFi.pedido.status == "recebido"
                ? "#FFC107"
                : this.dialogFi.pedido.status.match("tele")
                ? "#4CAF50"
                : "green"
            }`,
          }
        : "";
      this.statusPgto = await axios.post(
        `${process.env.VUE_APP_APIURL}/pagamentos/sitef/check`,
        {
          empresa: process.env.VUE_APP_DATABASE.toString(),
          order_id: this.dialogFi.pedido.num.toString()
        },
      );
      this.dialogFi.pedido.statusPgto = this.statusPgto.data;
      store.commit("incrementOldStatus", {
        statusPgto: this.dialogFi.pedido.statusPgto,
        pedido: this.dialogFi.pedido.num,
      });
    },
    dialogFi() {
      if (this.oldStatus.pedido == this.dialogFi.pedido.num) {
        this.dialogFi.pedido.statusPgto = this.oldStatus.statusPgto;
      } else {
        this.dialogFi.pedido.statusPgto = {
          message: "",
          data: {
            payment: { status: "" },
          },
        };
      }
    },
  },

  computed: {
    ...mapGetters(["dialogFi", "oldStatus"]),
  },
  methods: {},
  async mounted() {},
  async activated() {},
};
</script>
<style lang="scss" scoped></style>
<style scoped>
::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
</style>
